import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
//moved to cdn
// import '../contact-list.css'
// import '../contact-list-responsive.css'
import { getContactSchedules, getContactTimeline, removeScheduleBroadcast } from '../../../api/contactApi';
import NoteList from './NoteList';
import FileList from './FileList';
import CoreConstants from '../../../constants/CoreConstants';
import LogList from './Loglist';
import { DropdownHelper } from '../../globals/DropdownHelper';
import ContactTimelineLog from './ContactTimelineLog';
import { reloadConversationList } from '../../../actions/contactAction';
import ActivityList from './ActivityList/ActivityList';
import NewLoader from '../../common/NewLoader';
import { confirmAlert } from 'react-confirm-alert';
import { withTransaction } from '@elastic/apm-rum-react'
import Skeleton from '@material-ui/lab/Skeleton';
import "./MiddleSide.css";
import DealConfirmAlert from '../../common/custom-alert/new-alert/DealConfirmAlert';
import { useHistory } from "react-router-dom";

const allCommunicationTypes = [
    {id:0, value:CoreConstants.Timeline.CONTENT_TYPES[0]},
    {id:'scheduled',value:CoreConstants.Timeline.CONTENT_TYPES['scheduled']},
    {id:1,value:CoreConstants.Timeline.CONTENT_TYPES[1]},
    {id:2,value:CoreConstants.Timeline.CONTENT_TYPES[2]},
    {id:3,value:CoreConstants.Timeline.CONTENT_TYPES[3]},
    {id:4,value:CoreConstants.Timeline.CONTENT_TYPES[4]},
    {id:5,value:CoreConstants.Timeline.CONTENT_TYPES[5]},
    {id:7,value:CoreConstants.Timeline.CONTENT_TYPES[7]},
    {id:15,value:CoreConstants.Timeline.CONTENT_TYPES[15]},
    {id:25,value:CoreConstants.Timeline.CONTENT_TYPES[25]},
    {id:23,value:CoreConstants.Timeline.CONTENT_TYPES[23]},
    {id:21,value:CoreConstants.Timeline.CONTENT_TYPES[21]},
    {id:14,value:CoreConstants.Timeline.CONTENT_TYPES[14]},
    {id:22,value:CoreConstants.Timeline.CONTENT_TYPES[22]},
    {id:24,value:CoreConstants.Timeline.CONTENT_TYPES[24]},
    {id:24,value:CoreConstants.Timeline.CONTENT_TYPES[26]}
];
const allCommunicationTypesV2 = [
    {id:'0', value: 'All'},
    {id:'scheduled',value: 'Scheduled'}, 
    {id:'4,14',value: 'Email/Video Email'},
    {id:'1,2',value: 'SMS/MMS'},
    {id:'3',value: 'Ringless Vmail'},
    {id:'5,7',value: 'All Calls'},
    {id:'5',value: 'Incoming Calls'},
    {id:'7',value: 'Outgoing Calls'},
    {id:'25',value: 'Call Recordings'},
    {id:'15',value: 'Chat'},
    {id:'21,22,24',value: 'Direct Mail'},
    {id:'23',value: 'Gifts'},
    {id:'26,30',value: 'Completed Forms'},
];
/* 
All
Scheduled
Email/Video Email
SMS/MMS
Ringless Vmail
All Calls
Incoming Calls
Outgoing Calls
Call Recordings
Chat
Direct Mail
Gifts
Completed Forms
*/

const allCommunicationTypeArray = [0, CoreConstants.Timeline.CONTENT_TYPE_SMS, CoreConstants.Timeline.CONTENT_TYPE_MMS,
    CoreConstants.Timeline.CONTENT_TYPE_OUTGOING_CALL, CoreConstants.Timeline.CONTENT_TYPE_LETTER, CoreConstants.Timeline.CONTENT_TYPE_GREETINGS_CARD,
    CoreConstants.Timeline.CONTENT_TYPE_VOICE, CoreConstants.Timeline.CONTENT_TYPE_VIDEO_EMAIL, CoreConstants.Timeline.CONTENT_TYPE_POST_CARD,
    CoreConstants.Timeline.CONTENT_TYPE_GIFT, CoreConstants.Timeline.CONTENT_TYPE_EMAIL, CoreConstants.Timeline.CONTENT_TYPE_CALL,
    CoreConstants.Timeline.CONTENT_TYPE_CALL_RECORD, CoreConstants.Timeline.CONTENT_TYPE_FORM_RESPONSE,
    CoreConstants.Timeline.CONTENT_TYPE_CALL_BRIGDE, CoreConstants.Timeline.CONTENT_TYPE_CHAT, CoreConstants.Timeline.CONTENT_TYPE_SMART_FORM_RESPONSE];

const MiddleSide = (props) => {
    const history = useHistory();
    const [componentLoading, setComponentLoading] = useState(true);
    const [contactTimelineList, setContactTimelineList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreData, setHasMoreData] = useState(false);
    const [selectedTab, setSelectedTab] = useState('all');
    const [contactFullName, setContactFullName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contentTypeList, setContentTypeList] = useState(allCommunicationTypeArray);
    const [selectedDropdown, setSelectedDropdown] = useState(allCommunicationTypeArray[0])
    const [scrolling, setScrolling] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true)
    const [scheduleTimelineList, setScheduleTimelineList] = useState([])

    useEffect(() => {
        try{
            if(history.location.state != undefined){
                if(history.location.state?.for == "show-mention-user"){
                    if(history.location.state?.notificationType == 3){
                        setSelectedTab('note')
                    }
                }
            }
        }
        catch(err){
            console.log("history.location.state", history.location.state, err)
        }
    }, [])

    useEffect(() => {
        // loadData(1);
        // updateContactInfo();
        loadJSForHeight();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        setComponentLoading(true)
        loadData(1);
        updateContactInfo();
    },[props.contact])

    useEffect(() => {
        if(props.reloadConversationStatus){
            if(!firstLoad){
                setTimeout(()=>{
                    setCurrentPage(1)
                    loadData(1)
                    props.reloadNeedForConversation(false);
                },2000)
                
            }else{
                props.reloadNeedForConversation(false);

            }
        }
        if(firstLoad){
            setFirstLoad(false)
        }

    }, [props.reloadConversationStatus]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadJSForHeight=()=>{

        try{
        
            if(document.querySelector('.single__contact_height .side_content_row .contact_details.white')){
                let heightForMiddleSide = document.querySelector('.single__contact_height .side_content_row .contact_details.white').offsetHeight;
                document.querySelector('.single__contact_height .side_content_row .contact_center_field.main-inbox_column').style.height=heightForMiddleSide+'px';
            }
        }catch(e){
            console.log(e)
        }
        
    }
    
    const updateSearchMailType = (type) => {
        if (type == allCommunicationTypeArray[0]) {
            setContentTypeList(allCommunicationTypeArray)
        } 
        // else if (type == CoreConstants.Timeline.CONTENT_TYPE_SCHEDULE_CONVERSATION) {
        else if (type == allCommunicationTypesV2[1].id) {
            setContentTypeList([type])
            fetchScheDuleData()
        }  
        else {
            // setContentTypeList([type])
            try{
                setContentTypeList(type.split(',').map(Number))
            }
            catch(error){
                setContentTypeList(allCommunicationTypeArray)
            }
        }
        setSelectedDropdown(type)
    }

    const fetchScheDuleData = async () => {
        setComponentLoading(true)

        await getContactSchedules({ contact_id: props.contactId })
            .then(response => {
                if (response.data !== undefined) {
                    if(response.data.success){
                        setScheduleTimelineList(response.data.data)

                    }else{
                        setScheduleTimelineList([])
                    }
                    setComponentLoading(false)

                    // if(page ===1){
                    //     setScheduleTimelineList(response.data.data.data)
                    // }else{
                        
                    //     setContactTimelineList(contactTimelineList.concat(response.data.data.data))

                    // }

                    // setComponentLoading(false)
                    // if (response.data.data.to < response.data.data.total) {
                    //     setHasMoreData(true);
                    //     setCurrentPage(page + 1)
                    // } else {
                    //     setHasMoreData(false);
                    // }
                
                }else {
                    setComponentLoading(false)
                }
            })
    }

    const loadData = async (page) => {
        await getContactTimeline({ contact_id: props.contactId, page: page })
            .then(response => {
                if (response.data !== undefined) {

                    if(page ===1){
                        setContactTimelineList(response.data.data.data)
                    }else{
                        
                        setContactTimelineList(contactTimelineList.concat(response.data.data.data))

                    }

                    setComponentLoading(false)
                    if (response.data.data.to < response.data.data.total) {
                        setHasMoreData(true);
                        setCurrentPage(page + 1)
                    } else {
                        setHasMoreData(false);
                    }
                } 
                else if (page > 1){
                    setComponentLoading(false)
                    setHasMoreData(false);
                }else {
                    setContactTimelineList([])
                    setComponentLoading(false)
                    setHasMoreData(false);

                }
                setScrolling(false)
                if(page <= 1){
                    if(window.updateNotificationCount !== undefined){
                        window.updateNotificationCount()
                    }
                }
            })
    }

    const updateContactInfo = async () => {


        let firstName = (props.contact.first_name !== undefined && props.contact.first_name != null) ? props.contact.first_name.trim() : '';
        let lastName = (props.contact.last_name !== undefined && props.contact.last_name != null) ? props.contact.last_name.trim() : '';

        setContactFullName((firstName + ' ' + lastName).trim())
        setContactNumber(props.contact.number !== undefined && props.contact.number != null ? props.contact.number : '')
        setContactEmail(props.contact.email !== undefined && props.contact.number != null ? props.contact.email : '')

    }

    const loadMoreData = (e) => {
        if (selectedDropdown !== 'scheduled' && hasMoreData && !scrolling && Math.round(e.target.scrollTop + e.target.clientHeight, 10) >= Math.round(e.target.scrollHeight, 10)) {
            setScrolling(true);

            setTimeout(() => {
                loadData(currentPage);
            }, 500);
        }
    }

    const removeSchedule=async (scheduleId, index)=>{

        DealConfirmAlert({
            onSubmit : async() => {
                await removeScheduleBroadcast({ id: scheduleId })
                .then(response => {
                    if(response.data.status === 'success'){
                        let tempScheduleList = [...scheduleTimelineList];
                        tempScheduleList.splice(index,1)
                        setScheduleTimelineList(tempScheduleList)
                    }
                })
            },
            title: `Are you sure?`,
            description: '',
            cancelText: 'No',
            symbol: 3,
            submitText: 'Yes'
        });

    }

    const loadingSkeleton = () => {
        let skeletons = [];
        for(let i=0; i<5; i++ ){
            skeletons.push(
                <div key={i} className={`skeleton_each_conversation ${(i%2 === 0) ? 'skeleton_right' : 'skeleton_left'}`}>
                    <Skeleton className="skeleton_conversation_avater" variant="circle" width={50} height={50} />
                    <div className="skeleton_conversation_details">
                        <Skeleton variant="rect" width={300} height={80} />
                        <Skeleton variant="text" width={200} />
                        <Skeleton variant="text" width={200} />
                    </div>
                </div>
            )
        }
        return skeletons;
    }
    
    return (
        <React.Fragment>
            {/* <div className="col s12 m12 l5 xl6 px-4 contact_center_field main-inbox_column"> */}
            <div className="col s12 m12 l5 xl6 px-4 contact_center_field main-inbox_column">

            <div className="center_field_tabs white contact__middle__inbox__wrapper">
                <div className="row m-0">
                    <div className="col s12 center_field_top py-3 contact__middle__inbox__top">
                        <ul className="tabs d-flex justify-content-between align-items-center contact__middle__inbox__ul">
                            <li className="tab col mr-2 contact__middle__inbox__top__col0 max-w-200" onClick={() => { setSelectedTab('all') }}>
                                <DropdownHelper
                                    // datalist={allCommunicationTypes}
                                    datalist={allCommunicationTypesV2}
                                    noneFieldRequired={true}
                                    noneFieldTitle="Select Communication Type"
                                    className={selectedTab === 'all' ?"middleside-communication-dropdown-text": ""}
                                    mapping={{ title: "value" }}
                                    menuItemClassName=""
                                    updateSelectedData={updateSearchMailType}
                                    selectedValue={selectedDropdown}
                                    updateDatatable={()=>console.log('update')}
                                    dropdownHeader={'typeChange'}
                                    parentDivClassName="ppc__select_owner"
                                />
                            </li>
                            <li className="tab col contact__middle__inbox__top__col1">
                                <a className={`px-1 ${selectedTab === 'note' ? "active" : ""}`} href="#!" onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedTab('note');
                                }}>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <svg className="mb-1 mr-2" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0)">
                                                <path d="M17.6437 1.88101L16.1187 0.356013C15.8897 0.127857 15.5796 -0.000244141 15.2563 -0.000244141C14.9329 -0.000244141 14.6228 0.127857 14.3938 0.356013L13.2875 1.46226C13.2305 1.51954 13.1985 1.59707 13.1985 1.67789C13.1985 1.75871 13.2305 1.83624 13.2875 1.89351L16.1063 4.71226C16.1635 4.76928 16.2411 4.8013 16.3219 4.8013C16.4027 4.8013 16.4802 4.76928 16.5375 4.71226L17.6437 3.60601C17.8719 3.37695 18 3.06682 18 2.74351C18 2.42021 17.8719 2.11008 17.6437 1.88101ZM13.3594 9.29976L12.1094 10.5498C12.04 10.6208 12.0008 10.716 12 10.8154V13.9966H2V3.99664H9.18125C9.2806 3.99588 9.3758 3.95668 9.44687 3.88726L10.6969 2.63726C10.7495 2.58481 10.7854 2.51791 10.7999 2.44505C10.8145 2.37219 10.807 2.29664 10.7786 2.22801C10.7501 2.15937 10.7019 2.10074 10.6401 2.05954C10.5782 2.01835 10.5056 1.99646 10.4312 1.99664H1.5C1.10218 1.99664 0.720644 2.15467 0.43934 2.43598C0.158035 2.71728 0 3.09881 0 3.49664L0 14.4966C0 14.8945 0.158035 15.276 0.43934 15.5573C0.720644 15.8386 1.10218 15.9966 1.5 15.9966H12.5C12.8978 15.9966 13.2794 15.8386 13.5607 15.5573C13.842 15.276 14 14.8945 14 14.4966V9.56539C14.0002 9.49109 13.9783 9.41841 13.9371 9.35657C13.8959 9.29473 13.8373 9.24652 13.7686 9.21806C13.7 9.1896 13.6245 9.18218 13.5516 9.19672C13.4787 9.21127 13.4118 9.24713 13.3594 9.29976Z"></path>
                                                <path d="M15.4007 5.41559C15.4577 5.47287 15.4897 5.5504 15.4897 5.63122C15.4897 5.71204 15.4577 5.78957 15.4007 5.84685L8.57567 12.6718L5.67568 12.9937C5.58497 13.0039 5.49313 12.9935 5.40697 12.9634C5.32082 12.9332 5.24257 12.884 5.17802 12.8195C5.11348 12.755 5.0643 12.6767 5.03414 12.5905C5.00398 12.5044 4.99361 12.4126 5.0038 12.3218L5.32568 9.42185L12.1507 2.59684C12.208 2.53982 12.2855 2.50781 12.3663 2.50781C12.4471 2.50781 12.5246 2.53982 12.5819 2.59684L15.4007 5.41559Z"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0">
                                                    <rect width="18" height="16" fill="white"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p className="text-gray m-0">Notes</p>
                                    </div>
                                </a>
                            </li>
                            <li className="tab col contact__middle__inbox__top__col2">
                                <a className={`px-1 ${selectedTab === 'activities' ? "active" : ""}`}  href="#!" onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedTab('activities');
                                }}>
                                    <div className="d-flex justify-content-center align-items-center">

                                        <svg className=" mr-2" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.5 11.001H6.5C6.36739 11.001 6.24021 11.0537 6.14645 11.1474C6.05268 11.2412 6 11.3684 6 11.501V12.501C6 12.6336 6.05268 12.7608 6.14645 12.8545C6.24021 12.9483 6.36739 13.001 6.5 13.001H15.5C15.6326 13.001 15.7598 12.9483 15.8536 12.8545C15.9473 12.7608 16 12.6336 16 12.501V11.501C16 11.3684 15.9473 11.2412 15.8536 11.1474C15.7598 11.0537 15.6326 11.001 15.5 11.001ZM15.5 1.00098H6.5C6.36739 1.00098 6.24021 1.05366 6.14645 1.14742C6.05268 1.24119 6 1.36837 6 1.50098V2.50098C6 2.63358 6.05268 2.76076 6.14645 2.85453C6.24021 2.9483 6.36739 3.00098 6.5 3.00098H15.5C15.6326 3.00098 15.7598 2.9483 15.8536 2.85453C15.9473 2.76076 16 2.63358 16 2.50098V1.50098C16 1.36837 15.9473 1.24119 15.8536 1.14742C15.7598 1.05366 15.6326 1.00098 15.5 1.00098ZM15.5 6.00098H6.5C6.36739 6.00098 6.24021 6.05366 6.14645 6.14742C6.05268 6.24119 6 6.36837 6 6.50098V7.50098C6 7.63358 6.05268 7.76076 6.14645 7.85453C6.24021 7.9483 6.36739 8.00098 6.5 8.00098H15.5C15.6326 8.00098 15.7598 7.9483 15.8536 7.85453C15.9473 7.76076 16 7.63358 16 7.50098V6.50098C16 6.36837 15.9473 6.24119 15.8536 6.14742C15.7598 6.05366 15.6326 6.00098 15.5 6.00098Z"></path>
                                            <path d="M4.3628 0.110296C4.32796 0.0753357 4.28656 0.0475969 4.24098 0.0286699C4.1954 0.00974288 4.14653 0 4.09717 0C4.04782 0 3.99895 0.00974288 3.95336 0.0286699C3.90778 0.0475969 3.86638 0.0753357 3.83155 0.110296L1.84155 2.08873L1.13217 1.39748C1.09733 1.36252 1.05593 1.33478 1.01035 1.31586C0.964771 1.29693 0.915901 1.28719 0.866546 1.28719C0.817191 1.28719 0.768321 1.29693 0.722739 1.31586C0.677157 1.33478 0.63576 1.36252 0.600921 1.39748L0.110296 1.88873C0.0753357 1.92357 0.0475969 1.96497 0.0286699 2.01055C0.00974286 2.05613 0 2.105 0 2.15436C0 2.20371 0.00974286 2.25258 0.0286699 2.29817C0.0475969 2.34375 0.0753357 2.38514 0.110296 2.41998L1.59748 3.90123C1.67172 3.9718 1.77022 4.01114 1.87264 4.01114C1.97506 4.01114 2.07356 3.9718 2.1478 3.90123L2.63498 3.41311L4.89123 1.15717C4.96153 1.08682 5.00125 0.991579 5.00178 0.892124C5.00231 0.792668 4.9636 0.697016 4.89405 0.625921L4.3628 0.110296ZM4.3628 5.08498C4.32796 5.05002 4.28656 5.02228 4.24098 5.00336C4.1954 4.98443 4.14653 4.97469 4.09717 4.97469C4.04782 4.97469 3.99895 4.98443 3.95336 5.00336C3.90778 5.02228 3.86638 5.05002 3.83155 5.08498L1.84155 7.07623L1.13217 6.38561C1.09733 6.35065 1.05593 6.32291 1.01035 6.30398C0.964771 6.28506 0.915901 6.27531 0.866546 6.27531C0.817191 6.27531 0.768321 6.28506 0.722739 6.30398C0.677157 6.32291 0.63576 6.35065 0.600921 6.38561L0.110296 6.87592C0.0753357 6.91076 0.0475969 6.95216 0.0286699 6.99774C0.00974286 7.04332 0 7.09219 0 7.14155C0 7.1909 0.00974286 7.23977 0.0286699 7.28535C0.0475969 7.33094 0.0753357 7.37233 0.110296 7.40717L1.59373 8.89155C1.66791 8.96209 1.76637 9.00143 1.86873 9.00143C1.9711 9.00143 2.06955 8.96209 2.14373 8.89155L2.63436 8.40123L4.89061 6.14436C4.96064 6.0745 5.00023 5.97979 5.00075 5.88088C5.00128 5.78196 4.9627 5.68684 4.89342 5.61623L4.3628 5.08498ZM1.99998 10.5009C1.17217 10.5009 0.481546 11.1728 0.481546 12.0009C0.481546 12.829 1.1728 13.5009 1.99998 13.5009C2.39781 13.5009 2.77934 13.3429 3.06064 13.0616C3.34195 12.7803 3.49998 12.3987 3.49998 12.0009C3.49998 11.6031 3.34195 11.2216 3.06064 10.9403C2.77934 10.659 2.39781 10.5009 1.99998 10.5009Z"></path>
                                        </svg>
                                        <p className="text-gray m-0">Activities</p>

                                    </div>
                                </a>
                            </li>
                            <li className="tab col contact__middle__inbox__top__col3">
                                <a href="#files_tab" className={`px-1 ${selectedTab === 'files' ? "active" : ""}`} onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedTab('files');
                                }}>
                                    <div className="d-flex justify-content-center align-items-center">

                                        <svg className="mb-1 mr-2" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.4529 10.5947L15.1719 16.8042C15.0114 17.113 14.5564 17.4395 14.205 17.4395L1.04762 17.4419C0.769658 17.4419 0.503156 17.3318 0.306748 17.1352C0.11034 16.9386 0 16.6724 0 16.3943L0.00212976 6.17746C0.00212976 5.59967 0.47052 5.13084 1.04837 5.13028L2.01037 5.12937V6.02186H1.36677C1.2408 6.02186 1.11982 6.07185 1.03068 6.16099C0.941636 6.25012 0.891555 6.37102 0.891555 6.49708L0.892495 16.0746C0.892495 16.3373 1.10538 16.5498 1.36781 16.5498H2.02694L5.13638 10.2596C5.31206 9.90827 5.64402 9.62429 5.9949 9.62429H13.61L13.6126 7.09291C14.1099 7.13902 14.5023 7.55147 14.5023 8.06048V9.62432H17.9949C18.4074 9.62855 18.7547 10.0364 18.4529 10.5947ZM2.61704 13.3834C2.58863 10.2524 2.61704 0.859076 2.61704 0.859076C2.61704 0.385142 3.00246 0 3.47592 0H10.3542C10.4644 0 10.5695 0.0461031 10.644 0.127191L12.8677 2.54325C12.9343 2.616 12.9717 2.71125 12.9717 2.80994V9.06889H12.2503V3.35039C12.2503 3.25145 12.1699 3.17109 12.0709 3.17109H10.3689C10.1697 3.17109 10.0077 3.00938 10.0077 2.81056V0.900826C10.0077 0.801855 9.92734 0.721519 9.82828 0.721519H3.47636C3.40047 0.721519 3.33871 0.78325 3.33871 0.859076V12.5959L2.78667 13.7128C2.7867 13.7126 2.61989 13.7004 2.61704 13.3834ZM10.7299 2.44994H11.8014L10.7299 1.28522V2.44994ZM11.1206 3.90585H4.4729C4.22798 3.90585 4.02916 4.10486 4.02916 4.34978C4.02916 4.59452 4.22817 4.79362 4.4729 4.79362H11.1208C11.3657 4.79362 11.5652 4.59436 11.5652 4.34978C11.5648 4.10505 11.3654 3.90585 11.1206 3.90585ZM11.5648 6.93478C11.5648 6.69004 11.3656 6.49123 11.1206 6.49123H4.4729C4.22798 6.49123 4.02916 6.69042 4.02916 6.93478C4.02916 7.17951 4.22817 7.37833 4.4729 7.37833H11.1208C11.3654 7.37836 11.5648 7.17951 11.5648 6.93478ZM4.02888 9.53728C4.02888 9.78199 4.22798 9.98084 4.47271 9.98084H4.6321C4.91267 9.19887 5.60816 9.09373 5.60816 9.09373H4.47271C4.22836 9.09373 4.02888 9.29255 4.02888 9.53728Z"></path>
                                        </svg>
                                        <p className="text-gray m-0">Files</p>

                                    </div>
                                </a>
                            </li>
                            <li className="tab col contact__middle__inbox__top__col4">
                                <a href="#log_tab" className={`px-1 ${selectedTab === 'logs' ? "active" : ""}`} onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedTab('logs');
                                }}>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <svg className="mb-1 mr-2" width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0)">
                                                <path d="M11.375 5.6875H7.4375V1.75C7.4375 1.26684 7.04566 0.875 6.5625 0.875H5.6875C5.20434 0.875 4.8125 1.26684 4.8125 1.75V5.6875H0.875C0.391836 5.6875 0 6.07934 0 6.5625V7.4375C0 7.92066 0.391836 8.3125 0.875 8.3125H4.8125V12.25C4.8125 12.7332 5.20434 13.125 5.6875 13.125H6.5625C7.04566 13.125 7.4375 12.7332 7.4375 12.25V8.3125H11.375C11.8582 8.3125 12.25 7.92066 12.25 7.4375V6.5625C12.25 6.07934 11.8582 5.6875 11.375 5.6875Z"></path>
                                            </g>
                                        </svg>
                                        <p className="text-gray m-0">Log</p>
                                    </div>
                                </a>
                            </li>
                            <li className="indicator" style={{ left: 0, right: 439 }}></li>
                        </ul>
                    </div>
                    {/* <!-- single contact center field conversation --> */}
                    {/* {componentLoading && */}
                        {/* <NewLoader loading={componentLoading} onlyLoader={true} size={25}/> */}
                    {/* } */}

                    <div className="pr-0 col s12">
                        {
                            (componentLoading || props.loadingData) ? (
                                <div className="inbox_loader" style={{padding: '0px 10px', display:'block', overflow: 'hidden'}}>
                                        {loadingSkeleton()}
                                </div>
                                    ) : (
                                <div className="all-messages" id="cutomScrollbar1" onScroll={(e) => loadMoreData(e)}>
                                        {
                                            scrolling && (
                                                <div className="load-more-inbox-thread">Loading more...</div>
                                                )
                                        }
                                </div>
                            )
                        }
                    </div>

                    {!componentLoading && !props.loadingData &&
                        <React.Fragment>
                            {selectedTab === 'all' &&
                                <div id="conversation_tab" className="col s12 active contact__middle__inbox__conversation__tab" style={{ display: "block" }}>
                                    <div className="awesome__scroll_bar conversation_container contact__middle__inbox__conversation__container"
                                        onScroll={(e) => loadMoreData(e)}
                                    >
                                        <div className="p-3 message__container contact__middle__inbox__msg__container">

                                            {/* {viewContactTimelineLog()} */}
                                            <ContactTimelineLog contactTimelineList={contactTimelineList}
                                            contentTypeList={contentTypeList} contactFullName={contactFullName}
                                            contactNumber={contactNumber} contactEmail={contactEmail}
                                            scheduleTimelineList={scheduleTimelineList}
                                            contactInfo={props.contact}
                                            removeSchedule={removeSchedule}/>

                                        </div>
                                    </div>
                                    {
                                        scrolling && (
                                            <div className="scroll-loader">
                                                <NewLoader loading={scrolling} onlyLoader={true} size={25}/>
                                            </div>
                                        )
                                    }
                                </div>
                            }
                            {selectedTab === 'note' &&
                                <NoteList contactId={props.contact.id} />
                            }
                            {selectedTab === 'files' &&
                                <FileList contactId={props.contact.id}/>
                            }
                            {selectedTab === 'logs' &&
                                <LogList contactId={props.contact.id}/>
                            }
                            {selectedTab === 'activities' &&
                                <ActivityList contactId={props.contact.id} contact={props.contact}/>
                            }
                        </React.Fragment>
                    }

                </div>

            </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        contact: state.contactReducer.contact,
        reloadConversationStatus: state.contactReducer.reloadConversation
    };
};

const mapDispatchToProps = dispatch => {
    return {
        reloadNeedForConversation: (params) => dispatch(reloadConversationList(params))
    };
}

export default withTransaction('contact-details-middleside','component')(connect(mapStateToProps, mapDispatchToProps)(MiddleSide));